export const scrollToEvent = (offset, callback) => {
  const fixedOffset = offset.toFixed();
  const onScroll = function () {
    if (window.scrollY.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll);
      callback();
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  });
};

export const debounce = (func, delay = 1000) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const getIndex = (item) => {
  const nodes = Array.prototype.slice.call(item.parentElement.children);
  return nodes.indexOf(item);
};

export const countingCharacters = function (input) {
  const characterCounter = document.createElement('div');
  characterCounter.classList.add('character-counter');
  characterCounter.innerText = `0 / ${input.getAttribute('maxlength')}`;
  input.closest('fieldset').append(characterCounter);
  input.addEventListener('input', function () {
    characterCounter.innerText = `${this.value.length} / ${this.getAttribute('maxlength')}`;
  });
};

export const validation = (el, operation) => {
  if (operation === 'add') {
    el.closest('fieldset').classList.add('has-error');
    el.closest('fieldset').setAttribute(
      'data-error',
      'To pole jest obowiązkowe, aby wziąć udział w konkursie',
    );
  } else if (operation === 'remove') {
    el.closest('fieldset').classList.remove('has-error');
    el.closest('fieldset').setAttribute('data-error', '');
  }
};

export const validateField = (el, char) => {
  const isValid = el.value.trim().length > char;

  if (!isValid) {
    validation(el, 'add');
  } else {
    validation(el, 'remove');
  }
  return isValid;
};

export const validateCheckbox = (el) => {
  if (!el.checked) {
    validation(el, 'add');
  } else {
    validation(el, 'remove');
  }
  return el.checked;
};

export const checkEmail = (emailAddress) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{2,}))$/;
  return re.test(String(emailAddress).toLowerCase());
};

export const validateEmail = (el) => {
  const isValid = checkEmail(el.value);

  if (!isValid) {
    validation(el, 'add');
  } else {
    validation(el, 'remove');
  }
  return isValid;
};

const spinnerHtml = `<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="3" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>`;

export const createSpinner = (formEl, opacity) => {
  formEl.querySelectorAll('input, textarea, button').forEach((input) => {
    input.setAttribute('disabled', '');
  });
  if (opacity) {
    formEl.classList.add('form-opacity');
  }
  const spinnerWrapper = document.createElement('div');
  spinnerWrapper.classList.add('spinner-wrapper');
  spinnerWrapper.innerHTML = spinnerHtml;
  formEl.append(spinnerWrapper);
};
